import React from "react";
import styled from "styled-components";

import useThemes from "../hooks/useThemes";
import Hero from "./HeroSection/Hero";
import { Sedes } from "./Sedes";

export const PageSedes = () => {
  window.scroll(0, 0)
  const { backgroundWhite } = useThemes();

  return (
    <Container background={backgroundWhite}>
      <Hero
        title="Sedes de atención"
        subtitle="ENCUENTRA LA SEDE MÁS CERCANA PARA EL SERVICIO QUE NECESITAS"
        imgSrc="img/Servicios/Citas-turnos.jpg"
        color={backgroundWhite}
      />
      <Sedes />
    </Container>
  );
};

const Container = styled.div`
  background-color: ${(props) => props.background};
`;
